/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getDashboardCountAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const getDashboardSessionCountSlice = createSlice({
  name: "Guest Dashboard Session Count Data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboardCountAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getDashboardCountAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getDashboardCountAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getDashboardSessionCountSlice.reducer;
